module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_vm._v("Chapter 1"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Belgium: Naked Neutral")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The Netherlands: Too Little, Too Late")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Switzerland: Nature’s Bastion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Scandinavia: Quasi-Neutrals")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Finland and the Gulf of Finland")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Imperial Russia: Fortifications in the West")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("The Soviet Union: To the Stalin Line")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Austria-Hungary")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9"), _c('span', {
    staticClass: "space-1"
  }, [_vm._v("Austria’s Successors Part 1: Yugoslavia and Czechoslovakia")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Austria’s Successors Part 2: Romania and Hungary")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Poland and Greece: Guardians of the Gates")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Corking the Mediterranean: The Turkish Straits and Gibraltar")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Italy: Master of the Mediterranean")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Iberia in War and Peace")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Great Britain Rules: From Granite to Concrete")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("France: Centre of Modern Fortifications")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17"), _c('span', {
    staticClass: "space-2"
  }, [_vm._v("Germany: Land of Blood, Iron and Steel")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix I: Armour")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix II: Artillery Development")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix III: Machine Guns")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix IV: Revolution in Artillery")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0